<template>
  <section class="app-bg-grey">
    <v-container>
      <h1>bbb {{ xpath }}</h1>
      <v-row>
        <v-col v-for="(st, index) in selbegtypes" :key="index" cols="3">
          <banner-card
            flat
            tile
            v-bind:title="st.name"
            style="justify-content: center; align-items: center"
            v-bind:imagesrc="st.images[0].fileUrl"
            :path="st.ref.path"
          >
          </banner-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");
import firebase from "firebase";
import BannerCard from "./BannerCard";
import TextCard from "./TextCard";
import IconTextCard from "./IconTextCard";
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    xpath: {
      type: false,
      required: false,
    },
  },
  data() {
    return {
      mess: "ddd",
      selbegtypes: [],
    };
  },
  components: {
    BannerCard,
    TextCard,
    IconTextCard,
  },
  created() {
    console.log(this.xpath)
    if (this.xpath) {
      fb.db
        .doc(this.xpath)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let st = doc.data();
            st.id = doc.id;
            st.ref = doc.ref;
            this.selbegtypes.push(st);
          });
        });
    }
  },
};
</script>
